module.exports = __webpack_public_path__ + "static/Angular-ef91ecc1b88f0b1c886ad200e7b630a5.jpg";